// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nul li[data-v-03a78b6f]{\n  list-style: none;\n  font-size: 13px;\n  color: #909399;\n}\n.app-el-transfer[data-v-03a78b6f]{\n  padding-left: 5%;\n  padding-bottom: 30px;\n}\n.app-el-transfer_text[data-v-03a78b6f]{\n  padding-right: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
